import { IAPIGetEditDonationModel } from "../interfaces";
import { RelatedItemsModel, RelatedSectionModel } from "./DonationAndItemModel";
import { ItemDetailPageModel } from "./ItemDetailPageModels";

export class ItemDonationModel {
  detailSection: ItemDetailPageModel;
  public includedItems?: RelatedItemsModel[];
  public recommendedItems?: RelatedItemsModel;
  relatedSectionData?: RelatedSectionModel;
  constructor(data?: Partial<ItemDonationModel>) {
    this.detailSection =
      (data && data.detailSection) || new ItemDetailPageModel();
    this.includedItems = data && data.includedItems;
    this.recommendedItems = data && data.recommendedItems;

    if (this.includedItems || this.recommendedItems) {
      this.relatedSectionData = new RelatedSectionModel({
        includedItems: this.includedItems
          ? new RelatedItemsModel(this.includedItems[0])
          : new RelatedItemsModel(),
        recommendedItems: new RelatedItemsModel(this.recommendedItems),
      });
    }
  }

  static deserializeAPIModel(
    data: IAPIGetEditDonationModel
  ): ItemDonationModel {
    const includedItems: RelatedItemsModel[] = [];

    if (data.options?.included?.anyAmount) {
      if (data.options.included.item) {
        const anyItem = RelatedItemsModel.deserializeAPIModel(
          data.options.included.item
        );
        includedItems.push(anyItem);
      }
    } else if (data.options?.included?.ranges) {
      data.options.included.ranges.forEach((range) => {
        if (range.item?.category === "Item") {
          const rangeItem = RelatedItemsModel.deserializeAPIModel(range.item);
          includedItems.push(rangeItem);
        }
      });
    }
    const mappedData: Partial<ItemDonationModel> = {
      detailSection: ItemDetailPageModel.deserializeAPIModel(data),
      includedItems: includedItems,
      recommendedItems: data.options?.recommended
        ? RelatedItemsModel.deserializeAPIModel(data.options.recommended)
        : undefined,
    };
    return new ItemDonationModel(mappedData);
  }
}
